import textServices from 'services/text-services'
import useMediaQuery from 'hooks/use-media-query'
import { NEIGHBARS_ASSETS } from '../constants'

const POSTS = [
  { file: 'neighbars-post_instagram-1', alt: 'Vecinos brindando con Heineken 0.0' },
  { file: 'neighbars-post_instagram-2', alt: 'Comunidad Neighbars' },
  { file: 'neighbars-post_instagram-3', alt: 'Comunidad Neighbars' },
  { file: 'neighbars-post_instagram-4', alt: 'Comunidad Neighbars' }
]

const CommunitySection = () => {
  // Mobile shows two posts (approved layout); desktop shows the four-post row.
  const isTablet = useMediaQuery('(min-width: 768px)')
  const posts = isTablet ? POSTS : POSTS.slice(0, 2)

  return (
    <section className="neighbars__community">
      <h2 className="neighbars__community-title">
        {textServices.findByText('neighbars/community/title', 'Los fans tienen más amigos.')}
      </h2>
      <div className="neighbars__community-texts">
        <p>
          {textServices.findByText(
            'neighbars/community/text1',
            'Uno de cada tres mexicanos afirman haber tenido conflictos o enfrentamientos directos con sus vecinos.'
          )}
        </p>
        <p>
          {textServices.findByText(
            'neighbars/community/text2',
            <>
              En Heineken, creemos que pueden volverse amigos a través de{' '}
              <b>una pasión en común: el fútbol</b>.
            </>
          )}
        </p>
      </div>
      <div className="neighbars__community-posts">
        {posts.map(({ file, alt }) => (
          <picture key={file}>
            <source media="(min-width: 1024px)" srcSet={`${NEIGHBARS_ASSETS}/desktop/${file}-desktop1280px.webp`} />
            <source media="(min-width: 768px)" srcSet={`${NEIGHBARS_ASSETS}/tablet/${file}-tablet.webp`} />
            <img src={`${NEIGHBARS_ASSETS}/${file}-mobile.webp`} alt={alt} />
          </picture>
        ))}
      </div>
    </section>
  )
}

export default CommunitySection
